export function InfoField({ label, value }: { label: string; value: string }) {
  return (
    <div>
      <p className="text-xs text-text-label mb-0.5">{label}</p>
      <p className="text-sm text-text-primary">{value}</p>
    </div>
  )
}
